import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Navbar from './navbar';
import GatewaySidebar from './GatewaySidebar';
import './SRCGateway.css';
import { ToolType, GatewayLogType } from '../utils/types';

interface SRCGatewayProps {
  children: React.ReactNode;
  darkMode: boolean;
  fontSize: number;
  expandedVisualisation: boolean;
  selectedTool: ToolType;
  loadingProjects: boolean;
  gatewayLogs: GatewayLogType[];
  loggedIn?: boolean;
  loggedInRefreshTrigger?: number;
  username?: string;
  onKeyDown: (evt: React.KeyboardEvent<HTMLElement>) => void;
  onContainerClick: () => void;
  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onToolSelect: (tool: ToolType) => void;
}

const SRCGateway = ({
  children,
  darkMode,
  fontSize,
  expandedVisualisation,
  selectedTool,
  loadingProjects,
  gatewayLogs,
  loggedIn,
  loggedInRefreshTrigger,
  username,
  onKeyDown,
  onContainerClick,
  onClickHandler,
  onToolSelect,
}: SRCGatewayProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return (
    <Container
      fluid
      className="container-fluid src-gateway-container"
      style={{
        fontSize: `${fontSize}pt`,
      }}
      data-theme={darkMode ? 'dark' : 'light'}
      onKeyDown={onKeyDown}
      onClick={onContainerClick}
    >
      {/* Main Content */}
      <div className="src-layout">
        {/* Sidebar */}
        <GatewaySidebar
          darkMode={darkMode}
          selectedTool={selectedTool}
          collapsed={sidebarCollapsed}
          loadingProjects={loadingProjects}
          onClickHandler={onClickHandler}
          onToolSelect={onToolSelect}
          onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
        />
        <div className="src-main-area">
          <div className="src-navbar-wrapper">
            <Navbar
              darkMode={darkMode}
              loggedIn={loggedIn}
              username={username}
              loggedInRefreshTrigger={loggedInRefreshTrigger}
              gatewayLogs={gatewayLogs}
              onClickHandler={onClickHandler}
            />
          </div>

          {/* Content */}
          <main className="src-content-column">{children}</main>
        </div>
        {/* Footer */}
        {/* FIXME: Less urgent, needs to be fixed postdeploying the first UI change. */}
        {/* {!expandedVisualisation && (
                <footer className="src-footer">
                <div className="footer-gradient-bar">
                  <div className="footer-content">
                    <p>
                      SRCNet Science Gateway
                      v0.2.1
                    </p>
                  </div>
                </div>
              </footer>
            )} */}
      </div>
    </Container>
  );
};

export default SRCGateway;
